import React, { useEffect, useState } from "react";
import D3Sunburst from "./D3Sunburst";
import VybesChart from "./VybesChart";
import "../styles/mindmap.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export default function CommunityPanel() {
  const [sunburst, setSunburst] = useState(null);
  const [trend, setTrend] = useState({ opened: [], closed: [] });
  const [userHighlights, setUserHighlights] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      setError(null);
      try {
        const resp = await fetch(`${API_BASE_URL}/frameworks/community-dashboard`, {
          headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
        });
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
        const data = await resp.json();
        setSunburst(data.sunburst);
        setTrend(data.trend || { opened: [], closed: [] });
        setUserHighlights(data.user_highlights || []);
      } catch (e) {
        setError("Could not load community data.");
        setSunburst(null);
        setTrend({ opened: [], closed: [] });
        setUserHighlights([]);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return (
    <section className="community-panel">
      <div className="community-panel-grid">
        {/* Community Map card */}
        <div className="community-card community-card--slender">
          <div className="card-copy">
            <div className="title">Community Map</div>
            <div className="subtitle">These are all the open Tabs in the Vybly community. <br/>Your Tabs are shown in yellow. Numbers indicate <br/>how many Tabs are open at that level.</div>
          </div>
          <div className="card-viz-right">
            {loading ? <div className="tiny-loading">Loading…</div> : error ? <div className="error">{error}</div> :
              (sunburst ? <D3Sunburst data={sunburst} userHighlights={userHighlights} width={112} height={112} /> : <div className="empty">No data.</div>)
            }
          </div>
        </div>

        {/* Community Vybes card */}
        <div className="community-card community-card--slender">
          <div className="card-copy">
            <div className="title">Community Vybes</div>
            <div className="subtitle">Momentum across Vybly (30d). <br/>Blue line: Tabs opened. <br/>Green line: Tabs closed.</div>
          </div>
          <div className="card-viz-right card-viz-right--vybes">
            {loading ? <div className="tiny-loading">Loading…</div> : error ? <div className="error">{error}</div> :
              <VybesChart opened={trend.opened} closed={trend.closed} />
            }
          </div>
        </div>
      </div>
    </section>
  );
}